(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["luxmo-condition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxmo-modal-group')) {
  customElements.define('luxmo-modal-group', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-luxmo-open]');
        if (opener && this.contains(opener)) {
          const dialog = this.querySelector('#' + CSS.escape(opener.dataset.luxmoOpen));
          if (!dialog || dialog.open) return;
          dialog.returnTarget = opener;
          dialog.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
          return;
        }
        const closer = event.target.closest('[data-luxmo-close]');
        if (closer) closer.closest('dialog')?.close();
      });
      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = dialog.previousOverflow || '';
          dialog.returnTarget?.focus({ preventScroll: true });
        });
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach((dialog) => {
        document.documentElement.style.overflow = dialog.previousOverflow || '';
        dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxmo-product-facts')) {
  customElements.define('luxmo-product-facts', class extends HTMLElement {
    connectedCallback() {
      this.build();
      if (!this.ready) {
        this.observer = new MutationObserver(() => this.build());
        this.observer.observe(this, {childList:true,subtree:true});
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    build() {
      const source = this.querySelector('[data-facts-source]');
      const target = this.querySelector('[data-facts-target]');
      if (!source || !target || this.ready) return;
      const names = {'brand':'brand','item name':'item','product name':'item','model':'model','model number':'model','type':'type','material':'material','color':'color','colour':'color','gender':'gender','size':'size','dimensions':'size','width':'width','height':'height','depth':'depth','shoulder strap':'strap','strap length':'strap','handle drop':'handle','serial number':'serial','serial':'serial','sku':'sku','accessories':'included','included items':'included',"what’s included":'included',"what\'s included":'included','condition':'condition','rank':'rank','condition notice':'notice','country of origin':'origin','origin':'origin','made in':'origin','hs code':'hsCode','hs-code':'hsCode','harmonized system code':'hsCode'};
      const values = {};
      const intro = [], notes = [];
      const work = source.cloneNode(true);
      const candidates = [...work.querySelectorAll('p,li,h2,h3,h4,h5,h6,div')].filter(el => !el.querySelector('p,li,div,table,ul,ol,h2,h3,h4,h5,h6'));
      let recognized = 0;
      for (const el of candidates) {
        if (el.querySelector('img,video,iframe') || el.closest('table')) continue;
        const chunks = el.innerHTML.split(/<br\s*\/?\s*>/i);
        const leftovers = [];
        for (const html of chunks) {
          const holder = document.createElement('div'); holder.innerHTML = html;
          const text = holder.textContent.trim();
          if (!text) continue;
          if (/^[-–—\s]*(general information|design|size|inventory|included items|condition)[-–—\s]*$/i.test(text) && holder.querySelector('strong,b')) continue;
          const match = text.match(/^([^:：]{1,40})\s*[:：]\s*([\s\S]*)$/);
          const key = match && names[match[1].trim().toLowerCase()];
          if (key) {
            if (values[key]) { leftovers.push(html); continue; }
            let remaining = holder.textContent.search(/[:：]/) + 1;
            const walker = document.createTreeWalker(holder, NodeFilter.SHOW_TEXT);
            while (remaining > 0 && walker.nextNode()) {
              const n = walker.currentNode, count = Math.min(remaining,n.textContent.length);
              n.textContent = n.textContent.slice(count); remaining -= count;
            }
            values[key] = holder.innerHTML; recognized++;
          } else if (/before purchasing.*accessories|see photos.*accessories/i.test(text)) notes.push(html);
          else leftovers.push(html);
        }
        if (leftovers.length) el.innerHTML = leftovers.join('<br>'); else el.remove();
      }
      const readMetafield = value => {
        const holder = document.createElement('span');
        holder.textContent = (value || '').trim();
        return holder.innerHTML;
      };
      const hsCode = readMetafield(this.dataset.hsCode);
      const countryOfOrigin = readMetafield(this.dataset.countryOfOrigin);
      if (hsCode) values.hsCode = hsCode;
      if (countryOfOrigin) values.origin = countryOfOrigin;
      if (!recognized) return;
      this.ready = true; this.observer?.disconnect();
      for (const el of [...work.querySelectorAll('p,div,span,strong,b')].reverse()) {
        if (!el.textContent.trim() && !el.querySelector('img,video,iframe,table')) el.remove();
      }
      for (const br of work.querySelectorAll('br')) {
        const meaningful = n => n && (n.nodeType === 3 ? n.textContent.trim() : n.nodeName !== 'BR');
        let before=br.previousSibling, after=br.nextSibling;
        while(before && !meaningful(before)) before=before.previousSibling;
        while(after && !meaningful(after)) after=after.nextSibling;
        if(!before || !after) br.remove();
      }
      const make = (tag, cls, text) => {const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;};
      const panel = title => {const e=make('details','lx-facts-panel');e.open=true;e.append(make('summary','',title));return e;};
      const description=panel(this.dataset.descriptionLabel || 'Description');description.open=false;
      const prose=make('div','lx-facts-prose');prose.innerHTML=work.innerHTML;description.append(prose);
      if (values.rank || values.condition) {
        description.append(make('h3','lx-facts-label','Condition & Wear'));
        const wear=make('div','lx-facts-wear');wear.innerHTML=values.rank || values.condition;description.append(wear);
      }
      const details=panel(this.dataset.detailsLabel || 'Details');const grid=make('dl','lx-facts-grid');
      for(const [key,label] of [['brand','Brand'],['type','Type'],['color','Color'],['condition','Condition'],['gender','Gender'],['model','Model number'],['serial','Serial number'],['material','Material'],['origin','Country of origin'],['item','Item name'],['sku','SKU'],['hsCode','HS Code'],['included',"What's included"]]) {
        const item=make('div','lx-facts-field'+(['sku','hsCode','included','item'].includes(key)?' lx-facts-wide':''));
        item.append(make('dt','lx-facts-label',label));const value=make('dd');value.innerHTML=values[key] || '';
        if(!value.textContent.trim() || /^(?:[-—–]|to be confirmed)$/i.test(value.textContent.trim())) value.textContent='';
        item.append(value);grid.append(item);
      }
      details.append(grid);
      const size=make('div','lx-facts-size');size.append(make('h3','lx-facts-label','Size'));
      let hasSize=false;
      for(const [key,label] of [['size',''],['width','Width'],['height','Height'],['depth','Depth'],['strap','Shoulder strap'],['handle','Handle drop']]) {
        if(!values[key]) continue;
        const line=make('p');line.innerHTML=values[key];
        if(!line.textContent.trim() || /^(?:[-—–]|to be confirmed)$/i.test(line.textContent.trim())) continue;
        if(label) line.prepend(document.createTextNode(label+': '));size.append(line);hasSize=true;
      }
      if(!hasSize) size.append(make('p','',''));
      details.append(size);
      if(values.notice) notes.push(values.notice);
      for(const html of notes){const note=make('p','lx-facts-note');note.innerHTML=html;details.append(note);}
      const link=make('a','lx-facts-contact',this.dataset.contactLabel || 'Request more photos or videos →');
      link.href=this.dataset.contactUrl;link.target='_blank';link.rel='noopener noreferrer';details.append(link);
      target.replaceChildren(description,details);source.hidden=true;target.hidden=false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
